import React from 'react'

import LoadingScreen from './Ingreso/loadingScreen.component';
import CarSlider from './Slider/CarSlider.component';
import CarStudioContainer from './CarStudio/carStudio.container';
import GETWebParams from '../helpers/GETWebParams';
import { getSliderData as sliderData } from '../helpers/strapi.helper';

const params = GETWebParams()
declare const window: any;

interface Props {}

interface State {
  openCarSlider: boolean,
  currentCarSelected: string,
  openCarStudio: boolean,
  startOnInteriorView: boolean,
  isTouchScreen: boolean
}

class Loading extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      openCarSlider: false,
      currentCarSelected: '',
      openCarStudio: false,
      isTouchScreen: false,
      startOnInteriorView: false,
    }
  }

  componentDidMount(): void {
    this.handleOpenCarSlider();
  }

  handleTouchScreen = () => {
    this.setState({
      isTouchScreen: true
    })
  }

  handleOpenCarSlider = () => {
    if(this.state.openCarStudio === true)
      return;
    //WEB GET PARAMS
    let loadedParam = false
    if(params.model !== undefined) {
      Object.keys(sliderData()).forEach((car: any, index: number) => {
        const sliderItem = sliderData()[car];
        if (sliderItem && (car.toLowerCase() === params.model.toLowerCase() || (sliderItem.name && sliderItem.name.toLowerCase() === params.model.toLowerCase()))) {
          this.handleOpenCarStudio(sliderItem.name)
          window.sendDataByUrlParams("MODELO", sliderItem.name, undefined, undefined)
          loadedParam = true
        }
      })
    }
    if(loadedParam === false){
      this.setState({
        openCarSlider: true
      })
    }
  }

  handleOpenCarSliderOLD = () => {
    //WEB GET PARAMS
    let loadedParam = false
    if(params.model !== undefined) {
      Object.keys(sliderData()).forEach((car: any, index: number) => {
        if( car.toLowerCase() === params.model.toLowerCase() ){
          if(params.view.toLowerCase() === "internal"){
            this.setState({
              startOnInteriorView: true
            }, () => {
              this.handleOpenCarStudio(car)
              window.sendDataByUrlParams("MODELO", car, undefined, undefined)
              loadedParam = true
            })
          }else{
            this.handleOpenCarStudio(car)
            window.sendDataByUrlParams("MODELO", car, undefined, undefined)
            loadedParam = true
          }
        }
      })
    }
    if(loadedParam === false){
      this.setState({
        openCarSlider: true
      })
    }
  }

  handleOpenCarStudio = (payload: string) => {
    console.log(payload);
    
    this.setState({
      openCarSlider: false,
      openCarStudio: true,
      currentCarSelected: payload
    }, () => 
    window.dataLayer.push({
      'event': 'hero_banner_click',
      'comp_page': {
      'name_banner': payload.toLowerCase(),
      'link': "https://www.hyundaicolombia.co/interactive-car-studio/"
      }
    }))
    
  }

  handleCloseCarStudio = () => {
    this.setState({
      openCarSlider: true,
      openCarStudio: false,
      currentCarSelected: ''
    })
  }

  render(): React.ReactNode {
      return(
        <div className='loading-component'>
          <LoadingScreen
            handleOpenCarSlider = {this.handleOpenCarSlider}
          />
          <CarSlider
            openCarSlider={this.state.openCarSlider}
            handleOpenCarStudio = {this.handleOpenCarStudio}
            handleTouchScreen = {this.handleTouchScreen}
          />
          <CarStudioContainer
            openCarStudio = {this.state.openCarStudio}
            currentCarSelected={this.state.currentCarSelected}
            startOnInteriorView={this.state.startOnInteriorView}
            handleCloseCarStudio = {this.handleCloseCarStudio}
            isTouchScreen = {this.state.isTouchScreen}
          />
        </div>
      )
  }
}

export default Loading